import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom"; // ✅ Importamos useNavigate y Link
import "../styles/nosotros.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../img/logoAmnorte.png";

const menuItems = [
  { name: "Inicio", link: "/" },
  { name: "Nosotros", link: "/nosotros" },
  {
    name: "Productos",
    link: "/productos",
    dropdown: [
      { name: "Tubería Redonda", link: "/tuberia-redonda" },
      { name: "Tubería Redonda-Cédulas", link: "/tuberia-cedulas" },
      { name: "Tubo Cerquero", link: "/tubo-cerquero" },
      { name: "Tubería Cuadrada", link: "/tuberia-cuadrada" },
      { name: "PTR y Perfiles Rectangulares", link: "/ptr" },
      { name: "Perfiles Puerta", link: "/perfil-puerta" },
      { name: "Perfiles Ventana", link: "/perfil-ventana" },
      { name: "Ángulos y Soleras", link: "/angulos-soleras" },
      { name: "Lámina R-101", link: "/lamina-R-101" },
    ],
  },
  {
    name: "Servicios",
    link: "/servicio",
    dropdown: [
      { name: "Corte Láser", link: "/servicio#corte_laser" },
      { name: "Corte de Tubo", link: "/servicio#corte_tubo" },
      { name: "Doblez", link: "/servicio#doblez" },
      { name: "Doblez de Tubo", link: "/servicio#doblez-tubo" },
    ],
  },
  { name: "Contácto", link: "/contacto" },
];
const NavBar = () => {
  const navigate = useNavigate(); // ✅ Hook para navegación

  const [navbarColor, setNavbarColor] = useState("transparent");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselElement = document.getElementById("main-carousel");
      const carouselHeight = carouselElement ? carouselElement.clientHeight : 500;

      if (scrollY < carouselHeight / 2) {
        setNavbarColor("transparent");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" style={{ background: navbarColor, transition: "background 0.3s ease-in-out" }} fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo Aceros y Metales" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <NavDropdown key={index} title={item.name} id={`dropdown-${index}`} style={{ color: "#fff" }}>
                  {/* ✅ Hacer que "Productos" sea clickeable y navegue */}
                  {item.link && (
                    <NavDropdown.Item onClick={() => navigate(item.link)} style={{ color: "#fff", fontWeight: "bold" }}>
                      {item.name}
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  {item.dropdown.map((subItem, subIndex) => (
                    <NavDropdown.Item key={subIndex} href={subItem.link} style={{ color: "#fff" }}>
                      {subItem.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to={item.link} key={index} style={{ color: "#fff", transition: "color 0.3s ease" }}>
                  {item.name}
                </Nav.Link>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

const MisionVision = () => {
  return (
    <section className="mision-vision-container container my-5">
      <div className="row">
        <div className="mision col-md-6">
          <h3>Misión</h3>
          <p>
            Brindar soluciones integrales de acero de la más alta calidad, con un servicio eficiente y
            confiable, satisfaciendo las necesidades de nuestros clientes en todo el país, y contribuyendo al
            desarrollo del sector industrial a través de una comercialización responsable y sostenible.
          </p>
        </div>
        <div className="vision col-md-6">
          <h3>Visión</h3>
          <p>
            Ser la empresa líder en la comercialización de acero a nivel nacional, reconocida por la excelencia
            en la distribución de productos, la satisfacción de nuestros clientes y nuestro compromiso con la
            sostenibilidad y el crecimiento del sector.
          </p>
        </div>
      </div>
    </section>
  );
};

const Productos = () => (
  <section className="nproductos text-center my-5">
    <h3>Nuestros Productos</h3>
    <div className="productos-container">
      <Link to='/tuberia-redonda' style={{ textDecoration: 'none' }}>
        <div className="producto"><p>Tubería Redonda</p><img src={require("../img/tuberia_redonda.JPG")} alt="Tubería Redonda" /></div>
      </Link>
      <Link to='/tuberia-cedulas' style={{ textDecoration: 'none' }}>
        <div className="producto"><p>Tubería Cédulas</p><img src={require("../img/tuberia_cedulas.JPG")} alt="Tubería Cédulas" /></div>
      </Link>
      <Link to='/tubo-cerquero' style={{textDecoration:'none'}}>
        <div className="producto"><p>Tubo Cerquero</p><img src={require("../img/tubo_cerquero.png")} alt="Tubo Cerquero" /></div>
      </Link>
      <Link to='/tuberia-cuadrada' style={{textDecoration:'none'}}>
      <div className="producto"><p>Tubería Cuadrada</p><img src={require("../img/tuberia_cuadrada.png")} alt="Tubería Cuadrada" /></div>
      </Link>
      <Link to='/ptr' style={{textDecoration:'none'}}>
      <div className="producto"><p style={{ fontSize: '13px' }}>PTR y Rectangulares</p><img src={require("../img/ptr.png")} alt="PTR" /></div>
      </Link>
      <Link to='/perfiles' style={{textDecoration:'none'}}>
      <div className="producto"><p>Perfiles</p><img src={require("../img/p-puerta-verde.png")} alt="Perfiles" /></div>
      </Link>
      <Link to='/lamina-R-101' style={{textDecoration:'none'}}>
      <div className="producto"><p>Lámina</p><img src={require("../img/Lamina.png")} alt="Lámina R-101" /></div>
      </Link>
    </div>
  </section>
);

const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "60px", height: "60px" }} />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="container fluid">
      <div className="row d-flex align-items-stretch">
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="contact-info text-center" style={{ textAlign: "justify" }}>
            <h5>CONTÁCTANOS</h5>
            <p style={{ color: "#fff" }}><strong>Email:</strong> contacto@aymnorte.com.mx</p>
            <p style={{ color: "#fff" }}><strong>Teléfono:</strong> +52 55 4782 9794</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CORPORATIVO</h5>
            <p>Calzada Mariano Escobedo #476,<br />Piso 12 Int. 1200 B, Anzures,<br />Miguel Hidalgo, Ciudad de México, C.P. 11590</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CEDIS</h5>
            <p>Carretera Federal México-Querétaro KM 100,<br />San Miguel de la Victoria, Jilotepec,<br />Estado de México, C.P. 54270</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-12">
          <p style={{ color: "#fff" }}>AMNorte Aceros y Metales &copy; 2025 - Todos los derechos reservados</p>
          <p>
            <Link to='/Avisos_Privacidad'>
              <a style={{ color: "white", textDecoration: "none" }}>Aviso de Privacidad |</a>
            </Link>
            <Link to='/Terminos_y_Condiciones'>
              <a style={{ color: "white", textDecoration: "none" }}> Términos y Condiciones</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

const VideoComponent = () => {
  const videoRef = useRef(null); // Crear una referencia para el video

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1.5; // Establecer la velocidad a 2x
    }
  }, []);

  return (
    <div className="video-container">
      <video
        ref={videoRef} // Asociar la referencia al video
        autoPlay
        muted
        loop
        playsInline
        className="video-custom"
        style={{ width: "100%", height: "auto" }}
      >
        <source src="/video/ROLADORA_DE_TUBO.mp4" type="video/mp4" />
        Tu navegador no soporta la etiqueta de video.
      </video>
    </div>
  );
};
const Nosotros = () => {
  return (
    <div>
      <NavBar />
      <VideoComponent />
      <MisionVision />
      <Productos />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Nosotros;

